<!-- CouponHelpModal.vue -->
<script setup>
import { watch } from "vue";
import { useDraggableModal } from "@/composables/useDraggableModal";

const props = defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(["close"]);

// 🔹 NOVO: arrastar o modal pelo título (não há cabeçalho próprio aqui).
// Este componente não desmonta entre aberturas (só alterna `show`), então
// recentraliza ao reabrir para a posição não persistir.
const {
  panelRef,
  panelStyle,
  isDragging,
  isDraggable,
  onHandlePointerDown,
  resetPosition,
} = useDraggableModal();

watch(
  () => props.show,
  (val) => {
    if (val) resetPosition();
  }
);

function closeModal() {
  emit("close");
}
</script>

<template>
  <div
    v-if="show"
    class="fixed inset-0 z-[9998] flex items-center justify-center bg-black/20"
    @click.self="closeModal"
  >
    <div
      ref="panelRef"
      :style="panelStyle"
      class="bg-surface rounded-lg p-4 max-w-md w-full shadow-lg max-h-[80vh] overflow-y-auto"
    >
      <h2
        class="text-xl font-semibold mb-3"
        :class="{
 'cursor-move select-none touch-none': isDraggable,
          'cursor-grabbing': isDragging,
        }"
        @pointerdown="onHandlePointerDown"
      >
        Sobre a seção de coupons
      </h2>

      <p class="text-sm leading-relaxed text-gray-800 mb-3">
        Nesta página, você pode gerenciar os <strong>coupons de desconto</strong>
        utilizados nos fluxos de assinatura e pagamento do Litterae. Cada coupon
        possui um <strong>código</strong>, um <strong>percentual de desconto</strong>,
        uma <strong>data de expiração</strong>, uma <strong>regra de elegibilidade</strong>
        e uma configuração de aplicação por ciclo.
      </p>

      <div
        class="mb-4 rounded-md border border-blue-200 
 bg-blue-50  px-3 py-2.5"
      >
        <p class="text-sm text-blue-900 leading-relaxed">
          <strong>Dica:</strong> Use <strong>Máximo de resgates</strong> para limitar
          quantas pessoas podem consumir um coupon. Quando esse campo fica vazio,
          o coupon é tratado como ilimitado.
        </p>
      </div>

      <ul
        class="list-disc pl-5 text-sm text-gray-700 space-y-1.5 mb-3"
      >
        <li>
          Use o campo de busca para localizar coupons rapidamente pelo
          <strong>código</strong>.
        </li>
        <li>
          Use os filtros de <strong>Status</strong>, <strong>Regra</strong> e
          <strong>Ciclos</strong> para refinar a listagem.
        </li>
        <li>
          Clique em <strong>Adicionar Coupon</strong> para cadastrar um novo
          coupon com código, desconto, expiração e regra de uso.
        </li>
        <li>
          A coluna <strong>Ativo</strong> permite ativar ou inativar rapidamente
          um coupon sem abrir o formulário de edição.
        </li>
        <li>
          A coluna <strong>Resgates</strong> mostra quantos usos efetivos já
          ocorreram em relação ao limite máximo configurado.
        </li>
        <li>
          Abra o menu de ações na coluna <strong>Ações</strong> para editar,
          visualizar detalhes ou excluir um coupon.
        </li>
        <li>
          Marque vários coupons na primeira coluna para realizar
          <strong>exclusões em lote</strong> pelo menu
          <strong>Ações em lote</strong>.
        </li>
        <li>
          Clique sobre qualquer linha da tabela para abrir o
          <strong>card de detalhes</strong> do coupon.
        </li>
      </ul>

      <div
        class="mb-4 rounded-md border border-yellow-200 
 bg-yellow-50  px-3 py-2.5"
      >
        <p class="text-sm text-yellow-900 leading-relaxed">
          <strong>Atenção:</strong> Inativar um coupon impede novos usos, mas não
          apaga o histórico de resgates já realizados.
        </p>
      </div>

      <div class="mt-2 text-right">
        <button
          @click="closeModal"
          class="px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>

